import {FC} from 'react'
import {Link} from 'react-router-dom'

const Error404: FC = () => {
  return (
    <div className='w-100'>
      <div className='wc-auth__error-code'>404</div>
      <h1 className='wc-auth__heading'>Seems there is nothing here</h1>
      <p className='wc-auth__subtitle'>
        The page you're after doesn't exist or has moved.
      </p>
      <Link to='/' className='wc-auth__submit'>
        Return home
      </Link>
    </div>
  )
}

export {Error404}
